module.exports = __webpack_public_path__ + "static/media/invoice.493ad43b.webp";